/* eslint-disable react/prop-types */
import React, { Component } from "react";
import Navbar from "react-bootstrap/lib/Navbar";
import Nav from "react-bootstrap/lib/Nav";
import NavItem from "react-bootstrap/lib/NavItem";
import NavDropdown from "react-bootstrap/lib/NavDropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import { withRouter } from "react-router-dom";
import { Image, Icon, Flag, Dimmer, Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  tsExpertAction, liveListAction, liveListMatrixAction,
  oscilloscopeAction, barGraphAction, dadosAction, logAction,
  reportAction, configAction, channelAction
} from "../../actions/changeActiveItemActions";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();
class BootstrapMenuBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownTitle: "",
      activeChannels: {
        channel1: false,
        channel2: false,
        channel3: false,
        channel4: false
      },
      languageKey: localStorage.getItem(Constants.LOCAL_STORAGE_KEY),
      language: UtilsInstance.getLanguageStringFromKey(
        Constants,
        Strings),
      isUpdatingLanguageDimmerActive: false
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "activeChannels", { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        this.setState({ activeChannels: data });
      });
  }

  handleSelect = (eventKey, channel) => {
    switch (eventKey) {
      case "/":
        this.props.onChangeTSExpert(channel);
        this.props.history.push("/");
        break;
      case "/live-list":
        this.props.onChangeLiveList(channel);
        this.props.history.push("/live-list");
        break;
      case "/live-list-matrix":
        this.props.onChangeLiveListMatrix(channel);
        this.props.history.push("/live-list-matrix");
        break;
      case "/oscilloscope":
        this.props.onChangeOscilloscope(channel);
        this.props.history.push("/oscilloscope");
        break;
      case "/bar-graph":
        this.props.onChangeBarGraph(channel);
        this.props.history.push("/bar-graph");
        break;
      case "/dados":
        this.props.onChangeDados(channel);
        this.props.history.push("/dados");
        break;
      case "/log":
        this.props.onChangeLog(channel);
        this.props.history.push("/log");
        break;
      case "/config":
        this.props.onChangeConfig(channel);
        this.props.history.push("/login-handler");
        break;
      default:
        break;
    }
  }

  handleLanguageChange = (lang) => {
    this.sendLanguageData(lang);
  }

  sendLanguageData = (lang) => {
    this.setState({ isUpdatingLanguageDimmerActive: true }, () => {

      fetch(Constants.REQUEST_IP_ADDRESS + "language_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ language: lang })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          localStorage.setItem(Constants.LOCAL_STORAGE_KEY, lang);
          window.location.reload();
        })
        .catch((error) => {
          alert(Strings.UNABLE_TO_ALTER_LANGUAGE + Strings.REASON_PA + error);
          this.setState({ isUpdatingLanguageDimmerActive: false });
        });
    });
  }

  createDropdown = (activeChannels) => {
    let channel1 = <></>;
    let channel2 = <></>;
    let channel3 = <></>;
    let channel4 = <></>;
    let dropdownTitle = "";
    let firstChannel = -1;


    if (localStorage.getItem(Constants.ACTIVE_CHANNEL) !== null
      && localStorage.getItem(Constants.ACTIVE_CHANNEL) !== undefined
      && localStorage.getItem(Constants.ACTIVE_CHANNEL) !== -1) {

      let lowestActiveChannel = -1;

      if (activeChannels.channel1 === true) {
        channel1 = <MenuItem eventKey={1}>{Strings.CHANNEL_1}</MenuItem>;
        if (lowestActiveChannel === -1) {
          lowestActiveChannel = 1;
        }
      }

      if (activeChannels.channel2 === true) {
        channel2 = <MenuItem eventKey={2}>{Strings.CHANNEL_2}</MenuItem>;
        if (lowestActiveChannel === -1) {
          lowestActiveChannel = 2;
        }
      }

      if (activeChannels.channel3 === true) {
        channel3 = <MenuItem eventKey={3}>{Strings.CHANNEL_3}</MenuItem>;
        if (lowestActiveChannel === -1) {
          lowestActiveChannel = 3;
        }
      }

      if (activeChannels.channel4 === true) {
        channel4 = <MenuItem eventKey={4}>{Strings.CHANNEL_4}</MenuItem>;
        if (lowestActiveChannel === -1) {
          lowestActiveChannel = 4;
        }
      }

      firstChannel = parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL));

      if (firstChannel < lowestActiveChannel) {
        console.log("Updatiando canal. Menor canal era :", firstChannel, " agora é :", lowestActiveChannel);
        firstChannel = lowestActiveChannel;
        localStorage.setItem(Constants.ACTIVE_CHANNEL, firstChannel);
      }

      console.log("Colocando o canal ativo como canal:", parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)));
      dropdownTitle = this.getDropdownTitle(firstChannel);
    }
    else {

      if (activeChannels.channel1 === true) {
        channel1 = <MenuItem eventKey={1}>{Strings.CHANNEL_1}</MenuItem>;
        if (firstChannel === -1) {
          firstChannel = 1;
        }
      }

      if (activeChannels.channel2 === true) {
        channel2 = <MenuItem eventKey={2}>{Strings.CHANNEL_2}</MenuItem>;
        if (firstChannel === -1) {
          firstChannel = 2;
        }
      }

      if (activeChannels.channel3 === true) {
        channel3 = <MenuItem eventKey={3}>{Strings.CHANNEL_3}</MenuItem>;
        if (firstChannel === -1) {
          firstChannel = 3;
        }
      }

      if (activeChannels.channel4 === true) {
        channel4 = <MenuItem eventKey={4}>{Strings.CHANNEL_4}</MenuItem>;
        if (firstChannel === -1) {
          firstChannel = 4;
        }
      }

      dropdownTitle = this.getDropdownTitle(firstChannel);
      console.log("Colocando o canal ativo como canal:", firstChannel);
      localStorage.setItem(Constants.ACTIVE_CHANNEL, firstChannel);
    }

    return (
      <NavDropdown id="nav-drop" style={fontStyle} title={dropdownTitle}>
        {channel1}
        {channel2}
        {channel3}
        {channel4}
      </NavDropdown>
    );
  }

  getDropdownTitle = (channel) => {
    switch (channel) {
      case 1:
        return Strings.CHANNEL_1;
      case 2:
        return Strings.CHANNEL_2;
      case 3:
        return Strings.CHANNEL_3;
      case 4:
        return Strings.CHANNEL_4;
      default:
        return Strings.CHANNEL_1;
    }
  }

  handleDropdownSelect = (eventKey) => {
    console.log("Selecionou um canal");
    this.setState({ dropdownTitle: this.getDropdownTitle(eventKey) }, () => {
      localStorage.setItem(Constants.ACTIVE_CHANNEL, eventKey);
      //this.props.history.push("/" + this.props.location.pathname.split("/")[1]);
      window.location.reload();
    });
  }

  componentDidMount = async () => {
    // Se não existir o local storage para o canal ativo no momento, criamos
    // ele com o canal ativo sendo o canal 1 por padrão
    console.log("Descobrindo canal inicial: ", localStorage.getItem(Constants.ACTIVE_CHANNEL));

    if (localStorage.getItem(Constants.ACTIVE_CHANNEL) === null
      || localStorage.getItem(Constants.ACTIVE_CHANNEL) === undefined
      || localStorage.getItem(Constants.ACTIVE_CHANNEL) === -1) {
      console.log("Local storage de canal não existe, criando");

      let activeChannels = await fetch(Constants.REQUEST_IP_ADDRESS + "activeChannels", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let firstChannel = -1;

      if (activeChannels.channel1 === true) {
        if (firstChannel === -1) {
          firstChannel = 1;
        }
      }

      if (activeChannels.channel2 === true) {
        if (firstChannel === -1) {
          firstChannel = 2;
        }
      }

      if (activeChannels.channel3 === true) {
        if (firstChannel === -1) {
          firstChannel = 3;
        }
      }

      if (activeChannels.channel4 === true) {
        if (firstChannel === -1) {
          firstChannel = 4;
        }
      }

      localStorage.setItem(Constants.ACTIVE_CHANNEL, firstChannel);
      window.location.reload();
    }
    else {
      this.retrieveData();
    }
  }

  render() {
    let activePage = { "activeItem": "/" + this.props.location.pathname.split("/")[1] };

    if (activePage.activeItem === "/login"
      || activePage.activeItem === "/login-handler"
      || activePage.activeItem === "/report"
      || activePage.activeItem === "/change-login"
      || activePage.activeItem === "/tags"
      || activePage.activeItem === "/segment-devices"
      || activePage.activeItem === "/wlan-config"
      || activePage.activeItem === "/ethernet-config"
      || activePage.activeItem === "/active-channels"
      || activePage.activeItem === "/pa-type"
      || activePage.activeItem === "/ts-expert-config") {
      activePage.activeItem = "/config";
    }
    const activeItem = activePage.activeItem;

    return (
      <Navbar fluid defaultExpanded inverse collapseOnSelect style={menuStyle}>
        <Navbar.Header>
          <Navbar.Brand>
            <Image style={noBorderStyle} src="./logo.png" alt="TS Scope PA Logo" href="/" size="tiny" />
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>

        <Navbar.Collapse>
          <Nav pullLeft bsStyle="pills" onSelect={(eventKey) => { this.handleDropdownSelect(eventKey); }}>
            {this.createDropdown(this.state.activeChannels)}
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/"
              active={activeItem === "/"}>
              {Strings.TS_EXPERT}
            </NavItem>
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/live-list"
              active={activeItem === "/live-list"}>
              {Strings.LIVE_LIST}
            </NavItem>
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/live-list-matrix"
              active={activeItem === "/live-list-matrix"}>
              {Strings.LIVE_LIST_MATRIX}
            </NavItem>
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/oscilloscope"
              active={activeItem === "/oscilloscope"}>
              {Strings.OSCILLOSCOPE}
            </NavItem>
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/bar-graph"
              active={activeItem === "/bar-graph"}>
              {Strings.BAR_GRAPH}
            </NavItem>
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/dados"
              active={activeItem === "/dados"}>
              {Strings.DADOS_MENU}
            </NavItem>
          </Nav>

          <Nav
            pullLeft
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={this.props.active}>
            <NavItem
              style={fontStyle}
              eventKey="/log"
              active={activeItem === "/log"}>
              {Strings.LOG}
            </NavItem>
          </Nav>

          <Nav
            pullRight
            bsStyle="pills"
            onSelect={eventKey => this.handleSelect(eventKey, this.props.channel)}
            activeKey={activeItem}>

            <NavDropdown
              role="menuitem"
              id="language-dropdown"
              eventKey={this.state.languageKey}
              title={this.state.language}
              onSelect={lang => this.handleLanguageChange(lang)}>

              <MenuItem
                eventKey="pt">
                {/* active={this.state.languageKey === Constants.PT_LANG_KEY}> */}
                <Flag name="br" />
                {Strings.PORTUGUESE}
              </MenuItem>

              <MenuItem
                eventKey="en">
                {/* active={this.state.languageKey === Constants.EN_LANG_KEY}> */}
                <Flag name="us" />
                {Strings.ENGLISH}
              </MenuItem>

              <MenuItem
                eventKey="es">
                {/* active={this.state.languageKey === Constants.ES_LANG_KEY}> */}
                <Flag name="es" />
                {Strings.SPANISH}
              </MenuItem>

            </NavDropdown>

            <NavItem
              style={fontStyle}
              eventKey='/config'
              active={activeItem === "/config"}>
              <Icon name="cog" />
              {Strings.CONFIG}
            </NavItem>
          </Nav>

        </Navbar.Collapse>

        <Dimmer page active={this.state.isUpdatingLanguageDimmerActive} >
          <Loader size="big">{Strings.UPDATING_LANGUAGE_WAITING}</Loader>
        </Dimmer>

      </Navbar>
    );
  }
}

const mapStateToProps = state => ({
  active: state.activeMenuItem.activeItem,
  channel: state.activeMenuItem.channel
});

const mapActionsToProps = {
  onChangeTSExpert: tsExpertAction,
  onChangeLiveList: liveListAction,
  onChangeLiveListMatrix: liveListMatrixAction,
  onChangeOscilloscope: oscilloscopeAction,
  onChangeBarGraph: barGraphAction,
  onChangeDados: dadosAction,
  onChangeLog: logAction,
  onChangeReport: reportAction,
  onChangeConfig: configAction,
  // Channel map
  onChangeChannel: channelAction,
};

const menuStyle = {
  backgroundColor: "#262626",
  padding: "8pt",
  borderRadius: "0pt",
  borderWidth: 0
};

const fontStyle = {
  fontSize: "medium"
};

const noBorderStyle = {
  border: "none",
  background: "none",
  marginTop: "-4pt"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(BootstrapMenuBar));
